import { DataLoaderOptions } from '../types';
import buildDatasetInfoData from './datasetInfo/buildDatasetInfoData';
import { LoadMode } from './types';

export const createDatasetInfoProperties = (isHidden: boolean, data?: DataLoaderOptions) => {
  if (!isHidden && data) {
    return {
      isHidden: false,
      data: buildDatasetInfoData(data),
    };
  }

  return {
    isHidden: true,
    data: [],
  };
};

export const getSourceNameFromLoadMode = (loadMode: LoadMode) => {
  if (loadMode === 'boardColumns') return 'Board';
  if (loadMode === 'query') return 'Filter';
  if (loadMode === 'workflowStates') return 'Team';
  return '';
};
